import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class QBOInvoiceReportSearchParams extends SearchParamsBase {
  static saveType = 'QBOInvoiceReportSearchParams';
  initialize() {
    this.OfficeId = '';
    this.NotExportedYet = '';
    this.FinalizedAfter = '';
    this.FinalizedBefore = '';
    this.YrmoList = '';
    this.InvoiceIdList = '';
    this.SearchType = '';
    this.Statuses = [];
  }
}
